
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface EmailProtocolSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const EmailProtocolSelector = ({ value, onChange }: EmailProtocolSelectorProps) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Label className="text-base font-medium">Connection Type</Label>
        <Tooltip>
          <TooltipTrigger asChild>
            <Info className="h-4 w-4 text-muted-foreground cursor-help" />
          </TooltipTrigger>
          <TooltipContent className="max-w-[250px]">
            <p>Choose IMAP for standard email servers, or Exchange for Microsoft Exchange accounts.</p>
          </TooltipContent>
        </Tooltip>
      </div>
      
      <RadioGroup
        value={value}
        onValueChange={onChange}
        className="flex flex-wrap gap-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="imap" id="imap" />
          <Label htmlFor="imap" className="cursor-pointer">IMAP/SMTP</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="exchange" id="exchange" />
          <Label htmlFor="exchange" className="cursor-pointer">Exchange</Label>
        </div>
      </RadioGroup>
    </div>
  );
};
